import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
  Sequence,
} from "remotion";
import { VideoProps } from "../types/competition";

export const MatchResult: React.FC<VideoProps> = ({ competition }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const theme = competition.theme || {
    primaryColor: "#3B82F6",
    secondaryColor: "#EF4444",
    backgroundColor: "#1F2937",
  };

  const team1 = competition.teams[0];
  const team2 = competition.teams[1];
  const winner =
    team1 && team2
      ? team1.score > team2.score
        ? team1.name
        : team2.score > team1.score
          ? team2.name
          : "平局"
      : null;

  // 分数动画
  const score1Progress = spring({
    frame: frame - 30,
    fps,
    config: { damping: 50 },
  });

  const score2Progress = spring({
    frame: frame - 30,
    fps,
    config: { damping: 50 },
  });

  const resultOpacity = interpolate(frame, [60, 90], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: theme.backgroundColor,
        fontFamily: "system-ui, sans-serif",
      }}
    >
      {/* 标题 */}
      <div
        style={{
          position: "absolute",
          top: 60,
          width: "100%",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#fff", fontSize: 42, margin: 0 }}>
          比赛结果
        </h1>
        <p style={{ color: "#9CA3AF", fontSize: 20, marginTop: 8 }}>
          {competition.name}
        </p>
      </div>

      {/* 比分展示 */}
      <div
        style={{
          position: "absolute",
          top: "40%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 80,
        }}
      >
        {/* 队伍 1 */}
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              width: 120,
              height: 120,
              borderRadius: "50%",
              backgroundColor: theme.primaryColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
            }}
          >
            <span style={{ fontSize: 40, color: "#fff" }}>
              {team1?.name.charAt(0)}
            </span>
          </div>
          <h2 style={{ color: "#fff", fontSize: 28, margin: "0 0 12px" }}>
            {team1?.name}
          </h2>
          <div
            style={{
              fontSize: 96,
              fontWeight: 900,
              color: theme.primaryColor,
              transform: `scale(${score1Progress})`,
            }}
          >
            {team1?.score}
          </div>
        </div>

        {/* 分隔符 */}
        <div style={{ color: "#fff", fontSize: 64, opacity: 0.5 }}>-</div>

        {/* 队伍 2 */}
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              width: 120,
              height: 120,
              borderRadius: "50%",
              backgroundColor: theme.secondaryColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
            }}
          >
            <span style={{ fontSize: 40, color: "#fff" }}>
              {team2?.name.charAt(0)}
            </span>
          </div>
          <h2 style={{ color: "#fff", fontSize: 28, margin: "0 0 12px" }}>
            {team2?.name}
          </h2>
          <div
            style={{
              fontSize: 96,
              fontWeight: 900,
              color: theme.secondaryColor,
              transform: `scale(${score2Progress})`,
            }}
          >
            {team2?.score}
          </div>
        </div>
      </div>

      {/* 胜负结果 */}
      <Sequence from={60}>
        <div
          style={{
            position: "absolute",
            bottom: 100,
            width: "100%",
            textAlign: "center",
            opacity: resultOpacity,
          }}
        >
          <div
            style={{
              display: "inline-block",
              padding: "16px 48px",
              backgroundColor:
                winner === "平局" ? "#6B7280" : "#10B981",
              borderRadius: 12,
              color: "#fff",
              fontSize: 32,
              fontWeight: 700,
            }}
          >
            {winner === "平局" ? "⚖️ 平局" : `🏆 ${winner} 获胜！`}
          </div>
        </div>
      </Sequence>
    </AbsoluteFill>
  );
};
